//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Announcements from '@/components/Announcements.vue'
import announcements from '@/graphql/queries/announcements/announcements.gql'

import { BILLING_TERM_MONTH } from '@/lib/constants'
import { isPaidPlan, isUnlimited } from '@/lib/plans'
import { UserPrefs } from '@/lib/prefs'
import { formatDate, formatDueDate, isDeviceMobile } from '@/lib/utils'

export default {
  name: 'TopNav',
  components: {
    announcements: Announcements
  },
  data() {
    const isMobile = isDeviceMobile()

    let prefs = new UserPrefs(this.$store)

    return {
      isMobile,
      prefs,
      displayNotifications: false,
      announcements: []
    }
  },
  apollo: {
    announcements: {
      query: announcements,
      skip() {
        return !this.isLoggedIn
      }
    }
  },
  computed: {
    hasLoadedProfile() {
      return this.$store.state.hasLoadedProfile
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    profile() {
      return this.$store.state.profile
    },
    finishedInitialLoad() {
      return this.$store.state.finishedInitialLoad
    },
    brandLinkPath() {
      return this.isLoggedIn ? '/dashboard' : '/'
    },
    onLandingPage() {
      return (
        this.$route.path === '/' ||
        this.$route.path.startsWith('/use-cases') ||
        this.$route.path.startsWith('/platforms') ||
        this.$route.path.startsWith('/features')
      )
    },
    hideSignup() {
      return (
        this.$route.path.startsWith('/connect') ||
        this.$route.path.startsWith('/signup')
      )
    },
    hasUnlimitedPosts() {
      if (!this.profile) {
        return false
      } else {
        return isUnlimited(this.profile.account.allowedMonthlyPosts)
      }
    },
    hasUnlimitedAccounts() {
      if (!this.profile) {
        return false
      } else {
        return isUnlimited(this.profile.account.allowedSocialAccounts)
      }
    },
    shouldShowAnnualPlanUpsell() {
      return (
        this.isLoggedIn &&
        this.profile.account.plan.monthlyPrice > 0.0 &&
        this.profile.account.billingTerm === BILLING_TERM_MONTH &&
        this.prefs.showAnnualUpsellBanner
      )
    },
    shouldShowPostponeUpdate() {
      return this.isLoggedIn && this.$store.state.postponeHasUpdate
    },
    accountPastDue() {
      return (
        this.profile &&
        this.profile.account.subscriptionStatus.toLowerCase() === 'past_due'
      )
    }
  },
  methods: {
    isPaidPlan,
    formatDate,
    formatDueDate,
    async handleLogoutClick() {
      await this.$store.dispatch('logout')
      this.$buefy.toast.open({
        message: 'Successfully logged out',
        type: 'is-info'
      })
      this.$router.push({ path: '/' })
    },
    refreshPage() {
      window.location.reload()
      return false
    },
    hideAnnualPlanUpsellBanner() {
      this.prefs.showAnnualUpsellBanner = false
    }
  }
}
